import { api_configuration } from "../../common";
import cs = api_configuration.types.client_state.alan_api;
import cr = api_configuration.libraries.gui_definition_lib.libraries.model_lib.types.client_request.alan_api;
import { applyOperationDefaults } from "./defaults";
import { IdPathBuilder } from "../navigation/IdPathBuilder";
import { DataStoreProtocolError, DatastoreProxy } from "../interface/DatastoreProxy";
import { createIdPathBuilderFromNode } from "../navigation/createIdPathFromNode";
import { iNode } from "../state/Node";

function mapCommandArguments(parameters_node: cs.Cnode): cr.Tnode_initialization {
	const command_arguments: cr.Tnode_initialization = {
		properties: {},
	};

	for (const [attribute_name, attribute] of parameters_node.properties.attributes) {
		switch (attribute.properties.type.state.name) {
			case "operation":
				break;
			case "property": {
				const property = attribute.properties.type.state.node;
				switch (property.properties.type.state.name) {
					case "collection": {
						const $ = property.properties.type.state.node;
						command_arguments.properties[attribute_name] = {
							type: [
								"collection",
								{
									entries: $.properties.entries.map(function ($) {
										return {
											initialization: mapCommandArguments($.properties.node),
										};
									}),
								},
							],
						};
						break;
					}
					case "file": {
						const $ = property.properties.type.state.node;
						switch ($.properties.is_set.state.name) {
							case "yes": {
								const is_set = $.properties.is_set.state.node;
								command_arguments.properties[attribute_name] = {
									type: [
										"file",
										{
											token: is_set.properties.token,
											extension: is_set.properties.extension,
										},
									],
								};
								break;
							}
							case "no":
								break;
						}

						break;
					}
					case "group": {
						const $ = property.properties.type.state.node;
						command_arguments.properties[attribute_name] = {
							type: [
								"group",
								{
									initialization: mapCommandArguments($.properties.node),
								},
							],
						};
						break;
					}
					case "number": {
						const $ = property.properties.type.state.node;
						command_arguments.properties[attribute_name] = {
							type: [
								"number",
								{
									value: $.properties.is_set.cast("yes").properties.number.value,
								},
							],
						};
						break;
					}
					case "state group": {
						const $ = property.properties.type.state.node;
						const selected_state = $.properties.is_set.cast("yes").properties.state.ref;
						command_arguments.properties[attribute_name] = {
							type: [
								"state group",
								{
									state: selected_state.key.entry,
									initialization: mapCommandArguments(selected_state.properties.node),
								},
							],
						};
						break;
					}
					case "text": {
						const $ = property.properties.type.state.node;
						command_arguments.properties[attribute_name] = {
							type: [
								"text",
								{
									value: $.properties.is_set.switch({ yes: ($) => $.properties.text, no: () => "" }),
								},
							],
						};
						break;
					}
					default:
						unexpectedState(property.properties.type.state);
				}
				break;
			}
			default:
				unexpectedState(attribute.properties.type.state);
		}
	}
	return command_arguments;
}

function createCommandExecutionRequest(
	context_id_path: IdPathBuilder,
	command: cs.Cyes__started
): cr.Tcommand_execution {
	return {
		"context node": context_id_path.build(),
		command: command.parent.parent.key.entry,
		arguments: mapCommandArguments(command.properties.node),
	};
}

export async function executeCommand(command: cs.Cyes__started): Promise<void> {
	if (command.destroyed === true) return;
	switch (command.parent.parent.parent.properties.location.state.name) {
		case "remote": {
			const context_id_path_builder = createIdPathBuilderFromNode(command.parent.parent.parent);
			command.properties.executing.set("yes", { "can continue": ["no", {}] });
			try {
				await DatastoreProxy.instance.execute(createCommandExecutionRequest(context_id_path_builder, command));
				if (command.destroyed) {
					return;
				}
				iNode(command.properties.node).discard();
				command.properties.executing.set("no", {
					"last result": ["success", {}],
				});
				applyOperationDefaults(command);
			} catch (error) {
				if (error instanceof DataStoreProtocolError) {
					if (command.destroyed) {
						return;
					}
					command.properties.executing.set("no", {
						"last result": ["failure", {}],
					});
					throw error;
				} else {
					throw error;
				}
			}
			break;
		}
		case "local":
			break;
		default:
			unexpectedState(command.parent.parent.parent.properties.location.state);
	}
}
